import { Box, Paper, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

import { color, shadows, space } from "../theme/designTokens";

type SettingsSectionProps = {
  title: string;
  children: ReactNode;
};

export const SettingsSection = ({ title, children }: SettingsSectionProps) => (
  <Box>
    <Typography variant="h6" mb={space.xs}>
      {title}
    </Typography>
    <Paper
      variant="outlined"
      sx={{
        borderColor: color.panelBorder,
        boxShadow: shadows.card,
        p: space.sm,
      }}
    >
      <Stack gap={space.xs}>{children}</Stack>
    </Paper>
  </Box>
);
